import { Grid, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import _ from "lodash";
import React, { useEffect } from "react";
import { BackendTemplate } from "../../model/model/gencode/BackendTemplate";
import { Model } from "../../model/setup-sequelize/Model";
import { useGlobalStyles } from "../../style/GlobalStyle";
import BaseDialog from "../genaral-component/BaseDialog";
import clsx from "clsx";
type Props = {
	isDisplay: boolean;
	item: BackendTemplate;
	onEdit: (item: Model) => void;
	onCancel: () => void;
};
export default function DialogEditTemplate(props: Props) {
	const formik = useFormik<BackendTemplate>({
		initialValues: {} as BackendTemplate,
		onSubmit: () => {
			props.onEdit(formik.values);
		},
	});

	useEffect(() => {
		if (props.isDisplay) {
			formik.setValues(
				_.cloneDeep({
					...props.item,
					name: props.item.name || "NewTable",
				})
			);
		}
	}, [props]);
	const globalStyles = useGlobalStyles();
	return (
		<Grid>
			<BaseDialog
				isDisplay={props.isDisplay}
				onCancel={props.onCancel}
				onClickConfirm={() => {
					formik.submitForm();
				}}
				title="Edit table"
			>
				<Grid container direction="column" justify="space-around">
					<Grid>
						<TextField
							value={formik.values.name}
							helperText={
								formik.touched.name && formik.errors.name
							}
							name= "name"
							onChange = {formik.handleChange}
							fullWidth
							className={clsx(globalStyles.mt1, globalStyles.mb1)}
							label="Name"
						></TextField>
					</Grid>
					<Grid>
						<TextField
							value={formik.values.host}
							helperText={
								formik.touched.host && formik.errors.host
							}
							name = "host"
							onChange = {formik.handleChange}
							fullWidth
							className={clsx(globalStyles.mt1, globalStyles.mb1)}
							label="Host"
						></TextField>
					</Grid>
				</Grid>
			</BaseDialog>
		</Grid>
	);
}
